import { useQuery } from "@tanstack/react-query";
import { DailyReportModel } from "models";
import { getDailyExpandedReport } from "services/auditService";

export function useAuditDashboardDailyExpandedReport(
  storeId: string | null | undefined,
  startDate: string | null | undefined,
  endDate?: string | null | undefined
) {
  const resolvedEndDate = endDate ?? startDate;

  return useQuery<DailyReportModel | null, Error>({
    queryKey: ["audit-dashboard-daily-expanded-report", storeId, startDate, resolvedEndDate],
    queryFn: () => getDailyExpandedReport(storeId!, startDate!, resolvedEndDate!),
    enabled: Boolean(storeId && startDate && resolvedEndDate),
  });
}
